import React from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

const ContentSwapper = (props) => {
  const content = React.Children.toArray(props.children);
  return (
    <ReactCSSTransitionGroup transitionName='trans__fade' transitionEnterTimeout={300} transitionLeaveTimeout={300}>
      {props.swap ? content[1] : content[0]}
    </ReactCSSTransitionGroup>
  );
}

export default ContentSwapper;

ContentSwapper.propTypes = {
  children: PropTypes.array, 
  swap: PropTypes.bool
}


// WEBPACK FOOTER //
// ./src/components/content-swapper/contentSwapper.js